/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconAdjustmentsMinus = createReactComponent(
  "adjustments-minus",
  "IconAdjustmentsMinus",
  [
    ["path", { d: "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", key: "svg-0" }],
    ["path", { d: "M6 4v4", key: "svg-1" }],
    ["path", { d: "M6 12v8", key: "svg-2" }],
    ["path", { d: "M13.954 15.574a2 2 0 1 0 -1.954 2.426", key: "svg-3" }],
    ["path", { d: "M12 4v10", key: "svg-4" }],
    ["path", { d: "M12 18v2", key: "svg-5" }],
    ["path", { d: "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", key: "svg-6" }],
    ["path", { d: "M18 4v1", key: "svg-7" }],
    ["path", { d: "M18 9v6", key: "svg-8" }],
    ["path", { d: "M16 19h6", key: "svg-9" }]
  ]
);

export { IconAdjustmentsMinus as default };
//# sourceMappingURL=IconAdjustmentsMinus.js.map
